import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CodeReviewModel } from 'src/app/Models/code-review-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'code-review-view',
  templateUrl: './code-review-view.component.html',
  styleUrls: ['./code-review-view.component.scss']
})
export class CodeReviewViewComponent implements OnInit {
  reviewId!: string;
  projectId: string;
  activeTab: string = 'conversation'; // Default active tab
  codeReviewModel: CodeReviewModel;
  invalidCodeReview: boolean = false;
  currentUser: string = null;

  private subscriptions: Subscription = new Subscription();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private notifyService: NotifyService,
    private _codeReviewService: CodeReviewService,
    private _sharedService: SharedService,) {}

  ngOnInit(): void {
    this._sharedService.loaderHide.emit(true);
    this.currentUser = this.parseJwt(JSON.parse(localStorage.getItem("currentUser")).token).sub;
    this.updateActiveTab();
    // Subscribe to route params
    this.subscriptions.add(this.route.params.subscribe(params => {
      this.reviewId = params['reviewId'];
      this.projectId = localStorage.getItem("projectId");
      this.getCodeReviewModel();
    }));

    // Subscribe to router events
    this.subscriptions.add(this.router.events
      .pipe(filter(event => (event instanceof NavigationEnd && event.url.endsWith(`/code-link-review/${this.reviewId}`))))
      .subscribe(() => {
        this.updateActiveTab();
      })
    );

    // Subscribe to code review model updates
    this.subscriptions.add(this._codeReviewService.updateCodeReviewModel.subscribe(() => {
      this.getCodeReviewModel();
    }));
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to avoid memory leaks
    this.subscriptions.unsubscribe();
  }

  updateActiveTab() {
    switch(this.route.children[0].routeConfig.path) {
      case 'report':
        this.activeTab = "report";
        break;
      case 'code-changed':
        this.activeTab = "code-changed";
        break;
      default:
        this.activeTab = "conversation";
        break;
    }
  }

  getCodeReviewModel() {
    this._sharedService.loaderHide.emit(true);
    this._codeReviewService.getCodeReviewById(this.reviewId).subscribe(data => {
      if (data["data"] == null) {
        this.invalidCodeReview = true;
      } else {
        this.codeReviewModel = data["data"];
      }
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this._sharedService.loaderHide.emit(false);
    });
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  isCurrentUserCodeReview() {
    return this.currentUser != null && this.codeReviewModel != null &&  this.currentUser == this.codeReviewModel.created_by;
  }

  isCodeReviewMergeable(): boolean {
    return this.codeReviewModel.approved && this.isCurrentUserCodeReview() && this.codeReviewModel != null && this.codeReviewModel.state == 'OPENED';
  }

  mergeCodeReview() {
    this._sharedService.loaderHide.emit(true);
    this._codeReviewService.mergeCodeReviewByCodeReviewId(this.reviewId).subscribe(data => {
      if(data["operationStatus"] == "ERROR") {
        this._sharedService.loaderHide.emit(false);
        this.notifyService.notify('error', 'Failed', 'Error in merging Code review');
      } else {
        this._sharedService.loaderHide.emit(false);
        this.router.navigate([`/code-link-review`]);
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in merging Code review');
      this._sharedService.loaderHide.emit(false);
    });
  }
}
